import { Helmet } from "react-helmet";
import AboutBody from "../components/about/AboutBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function About() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.ntuna.com/solutions/about" />
        <meta
          name="description"
          content="Learn about NTUNA.COM, an international technology solutions company serving Uganda, the US and world wide with website, systems and app development, ICT consultancy and equipment supply, Digital marketing, CCTV & IT Security and Networking."
        />
        
        <meta
          property="og:description"
          content="Learn about NTUNA.COM, an international technology solutions company serving Uganda, the US and world wide with website, systems and app development, ICT consultancy and equipment supply, Digital marketing, CCTV & IT Security and Networking."
        />
        <meta property="og:title" content="NTUNA.COM | About" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | About" />
        <meta name="twitter:text:title" content="NTUNA.COM | About" />
        <meta
          name="twitter:description"
          content="Learn about NTUNA.COM, an international technology solutions company serving Uganda, the US and world wide with website, systems and app development, ICT consultancy and equipment supply, Digital marketing, CCTV & IT Security and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | About</title>
      </Helmet>
      <PageHero
        classes="world-bg"
        titleClasses="title uppercase ntuna-text-fill"
        title="About NTUNA.COM"
      />
      <AboutBody />
    </>
  );
}
